import React, { createContext, useContext, ReactNode, useEffect } from 'react';
import { AnchorProvider, Idl, Program } from '@coral-xyz/anchor';
import { useAnchorWallet, useConnection } from '@solana/wallet-adapter-react';
import { PublicKey } from '@solana/web3.js';
import { BILLBOARD_PROGRAM_ID } from "./constants"
import idl from './program_idl.json'

interface ProgramContextProps {
	children: ReactNode;
}

interface IProgramContext {
	program: Program | null;
}

const ProgramContext = createContext<IProgramContext | null>(null);

export const ProgramProvider: React.FC<ProgramContextProps> = ({ children }) => {

	const [program, setProgram] = React.useState<Program | null>(null);

	const { connection } = useConnection();

	const walletContext = useAnchorWallet();

	useEffect(() => {
		let provider = null;
		if (!walletContext) {
			provider = new AnchorProvider(connection, { publicKey: PublicKey.default, signAllTransactions: async (txs) => txs, signTransaction: async (tx) => tx }, {});
		} else {
			provider = new AnchorProvider(connection, walletContext, {});
		}
		setProgram(new Program(idl as Idl, new PublicKey(BILLBOARD_PROGRAM_ID), provider));
	}, [walletContext,]);

	return (
		<ProgramContext.Provider value={{ program }}>
			{children}
		</ProgramContext.Provider>
	);
};

export const useProgram = () => useContext(ProgramContext);

